import * as Sentry from '@sentry/react';
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    environment: import.meta.env.MODE,

    // Capture IP + user context for easier debugging
    sendDefaultPii: true,

    // Capture 10% of navigations for performance tracing
    tracesSampleRate: 0.1,

    // Replay only on errors (0 on normal sessions to save quota)
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={
      <div className="flex items-center justify-center min-h-screen bg-slate-900">
        <div className="text-center text-white p-8">
          <span className="material-symbols-outlined text-5xl text-brand-danger mb-4 block">error</span>
          <h1 className="text-xl font-bold mb-2">Algo salió mal</h1>
          <p className="text-slate-400 text-sm mb-4">El error fue reportado automáticamente.</p>
          <button
            onClick={() => window.location.reload()}
            className="px-4 py-2 bg-primary text-white rounded-xl text-sm"
          >
            Recargar
          </button>
        </div>
      </div>
    }>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
)

// ─── Actualización de la PWA ─────────────────────────────────────────────────
// El service worker cachea el bundle. Cuando se despliega una versión nueva,
// el SW se actualiza en segundo plano pero la pestaña abierta sigue ejecutando
// el JavaScript viejo: rutas nuevas no existen todavía y caen en el catch-all
// del router, mandando al usuario al inicio. Al tomar control el SW nuevo,
// recargamos una sola vez para que la pestaña use la versión recién publicada.
if ('serviceWorker' in navigator) {
  let reloading = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}
